export default __webpack_public_path__ + "static/media/medium.62f265eb.png";